module.exports = __webpack_public_path__ + "img/3.c069ce82.jpg";